import { StateCreator } from 'zustand'
import { Store } from '../type'
import { banners } from './constant'

type BannerSlice = Pick<Store, 'setBanner' | 'activeBanner' | 'removeBanner'>
export const bannerSlice: StateCreator<Store, [], [], BannerSlice> = (set) => ({
  activeBanner: null,
  removeBanner: () => set({ activeBanner: null }),
  setBanner: (type, message, link = '') => {
    const { text, variant } = banners()[type]
    set({
      activeBanner: {
        type,
        text: message ?? text,
        variant,
        link,
      },
    })
  },
})
